module.exports = __webpack_public_path__ + "img/flappy2.670eca22.png";